import type { TourStep } from "@/components/GuidedTour";

export const campaignTourSteps: TourStep[] = [
  {
    target: "",
    title: "Plan Your Campaign",
    titleAr: "خطّط لحملتك",
    description: "This is where every Fusion campaign starts. We'll show you the three things you can do from this screen.",
    descriptionAr: "من هنا تبدأ كل حملة على فيوجن. سنريك الأشياء الثلاثة التي يمكنك فعلها من هذه الشاشة.",
  },
  {
    target: "campaign-create",
    title: "Build From Scratch",
    titleAr: "ابنِ من الصفر",
    description: "Step through locations, dates, creatives, and payment with our guided builder. Auto-save keeps your progress safe.",
    descriptionAr: "تنقّل عبر المواقع والتواريخ والتصاميم والدفع مع المُنشئ الموجَّه. الحفظ التلقائي يحفظ تقدمك دائماً.",
  },
  {
    target: "campaign-drafts",
    title: "Pick Up Where You Left Off",
    titleAr: "تابع من حيث توقفت",
    description: "Every draft is saved automatically. Open one to continue editing — nothing gets lost between sessions.",
    descriptionAr: "تُحفظ كل مسودة تلقائياً. افتح أي مسودة لمواصلة التعديل — لا شيء يضيع بين الجلسات.",
  },
  {
    target: "campaign-dashboard",
    title: "Track Everything",
    titleAr: "تتبّع كل شيء",
    description: "Once submitted, monitor approvals, schedules, performance, and invoices from your dashboard.",
    descriptionAr: "بعد الإرسال، تابع الموافقات والجداول والأداء والفواتير من لوحة التحكم.",
  },
];
